import nuKenzie from "../Assets/img/NuKenzie.png";
import onePiece from "../Assets/img/OnePieceShop.png";
import MyDog from "../Assets/img/MyDogs.png";
import kenzieFood from "../Assets/img/KenzieFood.png";
import kenzieHub from "../Assets/img/kenzieHub.png";
import rickAndMorty from "../Assets/img/rick and morty.png";

export const arrayProjects = [
  {
    id: 1,
    name: "My Dog's Healthy",
    image: MyDog,
    about:
      "Projeto para cadastro e acompanhamento de vacinas e remédios de seus pet's.",
    slugButton1: "Repo",
    slugButton2: "Deploy",
    linkDeploy: "https://mydogshealth.vercel.app/dashboard",
    linkRepo: "https://github.com/anthonifelipi/my-dogs-health",
  },
  {
    id: 2,
    name: "Kenzie Food",
    image: kenzieFood,
    about:
      "Projeto de e-commerce com funcionalidades de carrinho de compras, busca e cadastro de produtos.",
    slugButton1: "Repo",
    slugButton2: "Deploy",
    linkDeploy: "https://api-kenziefood-m2-discacciati.vercel.app/",
    linkRepo: "https://github.com/anthonifelipi/api-kenziefood-m2",
  },
  {
    id: 3,
    name: "Nu Kenzie",
    image: nuKenzie,
    about:
      "Projeto para gerenciamento de gastos, cadastrando entradas e saídas.",
    slugButton1: "Repo",
    slugButton2: "Deploy",
    linkDeploy: "https://nu-kenzie-9a6d0rvye-anthonifelipi.vercel.app/",
    linkRepo: "https://github.com/anthonifelipi/Nu-Kenzie",
  },
  {
    id: 4,
    name: "One Piece Shop",
    image: onePiece,
    about:
      "Projeto de E-commerce com carrinho voltado a cultura pop com carrinho em pagina separada.",
    slugButton1: "Repo",
    slugButton2: "Deploy",
    linkDeploy: "https://one-piece-shop.vercel.app/",
    linkRepo: "https://github.com/anthonifelipi/One-Piece-Shop",
  },
  {
    id: 5,
    name: "Kenzie Hub",
    image: kenzieHub,
    about: "Projeto para cadastro de materias de estudo.",
    slugButton1: "Repo",
    slugButton2: "Deploy",
    linkDeploy: "https://kenzie-jjc5degmv-anthonifelipi.vercel.app/",
    linkRepo: "https://github.com/anthonifelipi/Kenzie-Hub",
  },
  {
    id: 6,
    name: "Rick and morty",
    image: rickAndMorty,
    about:
      "Projeto para requisicão em uma API buscando todos os personagens de rick and morty.",
    slugButton1: "Repo",
    slugButton2: "Deploy",
    linkDeploy: "https://requisicao-gwkz94u7u-anthonifelipi.vercel.app/",
    linkRepo: "https://github.com/anthonifelipi/Requisicao-Api",
  },
];
